import React, {Component} from 'react'
import {addContainer} from '../../api/ShopsApi'
import {StyleSheet, Modal, Image, TextInput, TouchableOpacity, View, ScrollView, Picker} from 'react-native'
import {Button, Text} from 'react-native-elements'
import {widthPercentageToDP as wp, heightPercentageToDP as hp} from 'react-native-responsive-screen'
import {percWidth, percHeight} from '../../api/StyleFuncs'
import {orderFormStyles} from './ContainerForm'
import logo from '../../../assets/midasRed.png'

 



export default class OrderForm extends Component{
    constructor(props){
        super(props)
        this.basket = []
        this.state = {
          shipment: {
            type: "contact"
          },
          message: {
            subject: '',
            text: '',
            html: "",
          },
          name: "",
          email: "",
          disableSubmit: true,
          submitting: false,
          
        }
       
    }

    onOrderUploaded = () => {
    console.log('order uploaded')
    /*
    //OPEN UP A CONFIRMATION MODAL
    */
  }


  componentDidMount = async () =>{

    this.checkValidity()
    
  }

  setMsg = () =>{
    let html = `
    <div>
    <h2>Hello ${this.state.name}, </h2>
    <br />
    <span>Thank you for your request!</span>
    <br />
    <span>Please follow the link below to complete your air freight request: \n</span>
    <br />
    <br />
    <a href = "https://midasaf-19a68.web.app\n" ><span><b>Air Freight Application \n</b> </span><a>
    <br />
    <br />
    <span>Regards, </span>
    <br />
    <br />
    <span>Midas Shipping </span>
    <br />
    <br />
    <h3>Please do not reply this e-mail</h3>


   </div>
    


  </div>
  `
          
    let message = {
      subject: 'Midas No Reply: Air Freight Request',
      text: '',
      html: html,
    }
    //this.setState({messgae: message})
    return message
  }




  


    onProductUploaded = () =>{
      console.log('product stock updated')
      
    }


    asyncForEach = async (array, callback) => {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    } 


    onClickSubmit = async () => {
      let msg = this.setMsg()
      this.setState({submitting: true})
      this.setState({message: msg}, async ()=>{
        alert("Your request is being submitted \n please wait...")
        try{
          await addContainer(JSON.parse(JSON.stringify(this.state)), this.onOrderUploaded)
          alert("Your request has been submitted.\nOur representative will be in contact shortly")
          const {navigation} = this.props
          navigation.navigate(
            'Landing Form',
            {order: this.state}
          )

        } catch (error) {
          console.warn(error)
          alert('Error: please check your internet connection and try again')
        }

    })
     
    }

 
    


    checkValidity = async () => {
      this.state.disableSubmit = false

      if (this.state.name === ""){
        this.state.disableSubmit = true
      }

      if (this.state.email === ""){
        this.state.disableSubmit = true
      }
      
      

      this.setState({forceRefresh: Math.floor(Math.random() * 100000000)})
      console.warn(this.state.disableSubmit)

    }
    


    render(){
        return(
            <ScrollView style = {orderFormStyles.regForm}>
                  <View style = {{marginBottom: 100}}>
                <Image source = {logo} style = {orderFormStyles.modalPic} />

                <Text style = {orderFormStyles.headerCenter} >AIR FREIGHT REQUEST</Text>
                <Text style = {orderFormStyles.subHeader} >Please submit your details and you will be contacted shortly with an application form</Text>  
                
                <Text style = {orderFormStyles.subHeader} >Name</Text>
                <TextInput style = {this.state.name !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. Ola Townsend"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.name}
                  onChangeText={(text) =>{
                    this.setState({ name: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>

                <Text style = {orderFormStyles.subHeader} >E-mail</Text>
                <TextInput style = {this.state.email !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                  placeholderTextColor = {'grey'}
                  placeholder = {"e.g. person@gmail.com"}
                  underlineColorAndroid= {'transparent'}
                  value={this.state.email}
                  onChangeText={(text) =>{
                    this.setState({ email: text})
                    setTimeout(()=>this.checkValidity(),500)
                    }}/>
             
            {this.state.submitting == true && 
            <View>
            <Text style = {orderFormStyles.modalSmallText}  >Submitting...{'\n'} </Text>    
             <Text  style = {orderFormStyles.modalSmallText}>Please check your junk mail in addition to your inbox</Text>  
             </View>
            }
                 <TouchableOpacity 
                  disabled = {this.state.disableSubmit}
                  style = {this.state.disableSubmit === false? orderFormStyles.modalButton: orderFormStyles.modalDisabledButton}
                  onPress = {() => this.onClickSubmit()}>
                  <Text style = {orderFormStyles.buttonText}>SUBMIT</Text>
                </TouchableOpacity>



                


                </View>

               

                
            </ScrollView>
      
        )
    }
  }




  
  